<template>
  <div class="HomespaceMyDay">
    <div class="HomespaceMyDay__title">My Day</div>
     <div class="HomespaceMyDay--task">
      <div class="itemsListCard--check"></div>
      <input value="Apples" />
    </div>
    <div class="HomespaceMyDay--task">
      <div class="itemsListCard--check"></div>
      <input value="Oranges" />
    </div>
    <div class="HomespaceMyDay--creator">
      <div class="HomespaceMyDay--icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="100%"
          height="100%"
          x="0"
          y="0"
          viewBox="0 0 512 512"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve"
          class=""
        >
          <g>
            <path
              d="M492 236H276V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v216H20c-11.046 0-20 8.954-20 20s8.954 20 20 20h216v216c0 11.046 8.954 20 20 20s20-8.954 20-20V276h216c11.046 0 20-8.954 20-20s-8.954-20-20-20z"
              fill="#757575"
              opacity="1"
              data-original="#757575"
              class=""
            ></path>
          </g>
        </svg>
      </div>
      <input class="HomespaceMyDay--new" placeholder="New Task" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.HomespaceMyDay {
  height: 100%;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  box-sizing: border-box;
  display: flex;
  -webkit-backdrop-filter: blur(var(--blur));
  backdrop-filter: blur(var(--blur));
  /*   border: 1px solid var(--border-color-lighter); */
  transition: border-color 0.3s ease-in-out;
  transition: all 0.2s ease-in-out;
  /*   box-shadow: 0 0 10px 1px #0000001a; */
  background-color: var(--glass-bg);
  width: 100%;
  flex-direction: column;
}
.HomespaceMyDay__title {
  font-size: 20px;
  padding: 10px;
  margin-bottom: 20px;
}
.HomespaceMyDay--task {
  display: flex;
  align-items: center;
  padding: 10px 10px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  box-sizing: border-box;
  display: flex;
  -webkit-backdrop-filter: blur(var(--blur));
  backdrop-filter: blur(var(--blur));
  border: 1px solid var(--border-color-lighter);
  transition: border-color 0.3s ease-in-out;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0 10px 1px #0000001a;
  background-color: #6060601c;
  height: 47px;
  margin: 3px 5px;
  width: auto;
}
.HomespaceMyDay--task:hover {
  border-color: var(--border-color);
}
.HomespaceMyDay--task input {
  background-color: transparent;
  color: white;
  font-size: 16px;
}
.itemsListCard--check {
  border-radius: 360px;
  width: 28px;
  height: 28px;
  color: #a7a7a7ba;
  box-shadow: 0 0 10px 1px #0000001a;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  flex-shrink: 0;
  border: 1px solid var(--border-color-lighter);
  margin-right: 10px;
}
.HomespaceMyDay--creator {
  display: flex;
  align-items: center;
  margin-top: auto;
  position: relative;
}
.HomespaceMyDay--icon {
  width: 15px;
  height: 15px;
  position: absolute;
  left: 15px;
}
.HomespaceMyDay--new {
  padding: 12px;
  padding-left: 40px;
  border-radius: 18px;
  border-radius: 12px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;
  margin: 0px auto;
  word-spacing: 1.25px;
  line-height: 25px;
  color: #2d2d2d;
  background-color: rgb(255 255 255 / 80%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(18px);
  margin-bottom: 0px;
  background-color: transparent;
  border-radius: 16px;
  -webkit-backdrop-filter: blur(var(--blur));
  backdrop-filter: blur(var(--blur));
  border: 1px solid var(--border-color-lighter);
  transition: border-color 0.3s ease-in-out;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0 10px 1px #0000001a;
  background-color: #6060601c;
  color: #fff;
}
</style>
